import { Component, HostListener, inject, ChangeDetectionStrategy } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog'
import { MatButton } from '@angular/material/button'
import { TranslatePipe } from '@ngx-translate/core'
import { SpinnerComponent } from '../spinner/spinner.component'

@Component({
  selector: 'app-info-dialog',
  standalone: true,
  imports: [MatDialogClose, MatButton, TranslatePipe, MatDialogActions, MatDialogContent, MatDialogTitle, SpinnerComponent],
  templateUrl: './info-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './info-dialog.component.scss',
})
export class InfoDialogComponent {
  data: {
    title?: string
    description?: string
    confirmLabel?: string
    displayConfirmButton?: boolean
    displayLoadingSpinner?: boolean
  } = inject(MAT_DIALOG_DATA)
  dialog = inject(MatDialogRef<InfoDialogComponent>)

  displayConfirmButton = this.data.displayConfirmButton ?? true
  displayLoadingSpinner = this.data.displayLoadingSpinner ?? false

  @HostListener('document:keydown', ['$event'])
  triggerKeys(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      this.closeDialog(false)
    }
    if (event.key === 'Enter') {
      this.closeDialog(true)
    }
  }

  closeDialog(afterCloseStatus: boolean) {
    this.dialog.close(afterCloseStatus)
  }
}
